module.exports = __webpack_public_path__ + "img/9_life-skills.1d9f47c5.png";